import React from 'react';

import { Tooltip, InfoIcon } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';

import './PropertyTypeFilterTooltip.scss';

const CONTENT_LIST_TRANS_KEYS = [
  'search.filter.property.tooltip.whole_apartment',
  'search.filter.property.tooltip.studio',
  'search.filter.property.tooltip.rooms',
  'search.filter.property.tooltip.residence'
];

const PropertyTypeFilterTooltip = () => {
  const content = (
    <ul className="property-type-filter-tooltip">
      {CONTENT_LIST_TRANS_KEYS.map(transKey => (
        <li
          key={transKey}
          dangerouslySetInnerHTML={{ __html: trans(transKey) }}
        />
      ))}
    </ul>
  );

  return (
    <Tooltip
      position={[Tooltip.POSITION_RIGHT, Tooltip.POSITION_BOTTOM]}
      color="blue-cerulean"
      tooltip={content}
    >
      <InfoIcon className="info__icon" size={20} />
    </Tooltip>
  );
};

export default PropertyTypeFilterTooltip;
